import { configureStore, combineReducers } from '@reduxjs/toolkit';
import filters from '../slices/filters';
import locationScans from '../slices/locationScans';
import preloader from '../slices/preloader';
import meQrData from '../slices/meQrData';
import mePageData from '../slices/mePageData';
import mePosData from '../slices/mePosData';
import saleFiltersSlice from '../slices/saleFiltersSlice';
import meTicketData from '../slices/meTicketData';

const rootReducer = combineReducers({
  filters,
  locationScans,
  preloader,
  meQrData,
  mePageData,
  mePosData,
  saleFiltersSlice,
  meTicketData,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});
